import React, { ReactNode, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useToast } from '../../contexts/ToastContext'

interface AuthWrapperProps {
  children: ReactNode
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const { user, session } = useAuth()
  const { addToast } = useToast()
  const navigate = useNavigate()
  const location = useLocation()
  const hasRedirected = useRef(false)

  useEffect(() => {
    // Check if user just signed in successfully and we haven't redirected yet
    if (user && session && 
        (location.pathname === '/login' || location.pathname === '/auth') && 
        !hasRedirected.current) {
      
      hasRedirected.current = true
      
      // Redirect to dashboard after successful sign-in
      navigate('/dashboard', { replace: true })
      addToast('Welcome back! You have successfully signed in.', 'success')
    }
    
    // Reset the redirect flag when user logs out
    if (!user || !session) {
      hasRedirected.current = false
    }
  }, [user, session, location.pathname, navigate, addToast])

  return <>{children}</>
}

export default AuthWrapper 